import React, { useContext, useState, useCallback } from "react";
import { isObjectEqual } from "../_helpers";
import { useSelector } from "react-redux";

const MapContext = React.createContext();

export function useMaps() {
  return useContext(MapContext);
}

export function MapProvider({ children }) {
  // const [mapCollection, setMapCollection] = useState([]);
  const [currentMap, setCurrentMap] = useState(null);
  const [coords, setCoords] = useState({ x: 0, y: 0, z: 0 });
  const [interactiveMode, setInteractiveMode] = useState(false);

  const { items: mapCollection } = useSelector((state) => state.maps);

  //Adjust zoom of current map
  function setZoom(zoom) {
    setCoords({
      ...coords,
      z: zoom,
    });
  }

  //Navigate to position on current map
  function goTo(newCoords) {
    // console.warn('Moving to Coords', newCoords);
    setCoords({
      ...coords,
      ...newCoords,
    });
  }

  //Navigate to position on another map
  async function goToMap(mapID = currentMap.id, newCoords = null) {
    let newMap = null;
    // console.warn('Changing Maps', { from: currentMap?.id, to: mapID });
    if (typeof mapID === "string") {
      newMap = await mapCollection.find((map) => map._id === mapID);
        // newMap = maps.find((map) => map._id === mapID);
        // console.log("NewMap", newMap);
        if (!newMap || newMap === null) {
          console.warn(`MAPCONTEXT: Unable to find map "${mapID}"`);
          return;
        }
        await setCurrentMap(newMap);
      // if (
      //   currentMap === null ||
      //   currentMap === undefined 
      // ) {
      //   // console.log('Map collection', mapCollection);
        
      // }
    } else {
      if (
        currentMap === null ||
        currentMap === undefined ||
        currentMap._id !== mapID._id
      ) {
        // if (!mapCollection.find((m) => m._id === mapID._id)) {
        //   // console.log('Checking map collection');
        //   addMapToChronicle(mapID);
        // } else {
        //   // console.log('Skipping map collection');
        // }
        // console.log('FINALLY changing Map!');
        await setCurrentMap(mapID);
      }
    }

    if (newCoords && newCoords !== null) {
      if (!isObjectEqual(newCoords, coords)) {
        // setTimeout(() => {
        //   setCoords({
        //     ...coords,
        //     ...newCoords,
        //   });
        // }, 100);
      } else {
        console.log(
          "New coords and existing coords are the same!!!",
          newCoords,
          coords
        );
      }
      setCoords({
        ...coords,
        ...newCoords,
      });
    } else {
      if (newMap && newMap.defaultCoords) {
        // setTimeout(() => {
        //   setCoords({
        //     ...coords,
        //     ...newMap.defaultCoords,
        //   });
        // }, 100);
      }
    }
  }

  //Add map to collection
  function addMapToChronicle(map) {
    // setMapCollection([...mapCollection, map]);
  }

  const getCurrentMap = () => {
    return currentMap;
  };

  //Remove a map based on mapID
  // function removeMapFromChronicle(mapID) {
  //   // const removeIndex = mapCollection.findIndex(map => map.id === mapID);
  //   const newCollection = mapCollection.filter((map) => map.id !== mapID);
  //   setMapCollection(newCollection);
  // }

  //Batch load a collection of maps
  function loadMaps(maps) {
    // console.log('Received new collection to add', maps);
    return;
    if (maps && maps.length > 0) {
      const oldMaps = mapCollection.filter((oldMap) => {
        if (maps.find((m) => m._id === oldMap._id)) {
          return false;
        }
        return true;
      });

      setMapCollection([...oldMaps, ...maps]);
    } else {
      // console.log('Unable to load an empty list of maps!');
    }
  }

  //Alias for mapCollection
  function getMaps() {
    return mapCollection;
  }

  function getCoords(asArray = false) {
    if (asArray) {
      return [coords.x, coords.y, coords.z];
    }
    return { ...coords };
  }

  //Get map properties without changing maps
  function getMapById(mapID) {
    return mapCollection.find((map) => map.id === mapID);
  }

  const toggleInteractiveMode = (mode = null) => {
    if (mode === null) {
      setInteractiveMode(mode);
    } else {
      setInteractiveMode((m) => !m);
    }
  };

  const value = {
    coords,
    currentMap,
    interactiveMode,
    getCurrentMap,
    toggleInteractiveMode,
    setCurrentMap,
    setCoords,
    getCoords,
    setZoom,
    goTo,
    goToMap,
    // addMap: addMapToChronicle,
    // removeMap: removeMapFromChronicle,
    loadMaps,
    getMaps,
    getMapById,
  };

  return <MapContext.Provider value={value}>{children}</MapContext.Provider>;
}
